import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import "../../../styles/ShopifyGeoNotAvailableMapPlaceholder.scss";

const ShopifyGeoNotAvailableMapPlaceholder: FC<{ label: string }> = ({ label }) => {
  const { t } = useTranslation();
  return (
    <div
      className="shopify-geo__city-map shopify-geo__city-map--not-available"
      role="img"
      aria-label={t("shopifyGeo.cityMap.notAvailableAria", {
        region: label,
        defaultValue: "{{region}} map is not available",
      })}
    >
      <Info size={20} aria-hidden />
      <span>{t("shopifyGeo.cityMap.notAvailable", { defaultValue: "Not Available" })}</span>
    </div>
  );
};

export default ShopifyGeoNotAvailableMapPlaceholder;
